module.exports = "Detail\n"